<template>
  <div
    :id="id"
    class="rating"
    :class="{
      'rating--summary-visible': summaryVisible,
      'rating--has-summary': showSummaryOnHover,
      'rating--product-overview': productOverviewPage,
    }"
    @mouseover="summaryVisible = true"
    @mouseleave="summaryVisible = false"
  >
    <component
      :is="tag"
      class="r-stars"
    >
      <div
        v-if="!bvEnabled"
        class="r-stars-wrapper"
      >
        <img
          src="assets/img/stars_empty.svg"
          :alt="$t('rating.stars.empty')"
        />
        <div
          class="r-stars--full"
          :style="{ width: computedWidth }"
        >
          <img
            src="assets/img/stars_filled.svg"
            :alt="$t('rating.stars.filled', { rating: absoluteRatingValue })"
          />
        </div>
      </div>

      <div
        v-else
        data-bv-show="rating_summary"
        :data-bv-product-id="productCode"
      />
    </component>

    <div
      v-if="count && !bvEnabled"
      class="r-count"
    >
      {{ absoluteRatingValue }} ({{ count }})
    </div>

    <div
      v-if="subline"
      class="r-subline"
    >
      {{ subline }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bvEnabled: {
      type: Boolean,
      default: false,
    },
    count: {
      type: [String, Number],
    },
    id: {
      type: String,
    },
    productCode: {
      type: [String, Number],
    },
    showSummaryOnHover: {
      type: Boolean,
    },
    stars: {
      type: [Number, String],
      required: true,
      default: 0,
    },
    subline: {
      type: String,
    },
    tag: {
      type: String,
      default: 'div',
    },
    productOverviewPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maxStars: 5,
      summaryVisible: false,
    };
  },
  computed: {
    absoluteRatingValue() {
      let stars = 0;
      if (typeof this.stars !== 'string') {
        stars = this.stars.toFixed(1);
      } else {
        stars = parseFloat(this.stars).toFixed(1);
      }

      return stars;
    },

    computedWidth() {
      const maxWidth = 70;
      return `${(maxWidth / 5) * this.absoluteRatingValue}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
.rating {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .r-stars {
    display: flex;
    text-decoration: unset;
    margin-right: $pad * 0.5;

    &:deep([data-bv-show='rating_summary'] .bv_main_container .bv_main_container_row_normal) {
      width: auto !important;
    }

    .r-stars-wrapper {
      position: relative;
      width: 70px;
      height: 14px;

      .r-stars--full {
        position: absolute;
        overflow: hidden;
        width: 0;
        height: 14px;
      }

      img {
        position: absolute;
        max-width: 70px;
        height: 14px;
        width: 70px;
        top: 0;
        left: 0;
      }
    }
  }

  .r-count {
    font-size: map-get($font-sizes, 's');
    line-height: 1em;
  }

  .r-subline {
    flex: 100%;
    font-size: map-get($font-sizes, 's');
    color: palette(grey);
  }

  .r-summary {
    position: absolute;
    display: none;
    top: 20px;
    left: 0;
    padding: $pad;
    background-color: $color-general-background-neutral-default;
    border: 1px solid palette(sand, light);
    box-shadow: 0 2px 3px rgba(palette(black), 0.1);
    z-index: 2;
  }

  &.rating--has-summary {
    .r-stars {
      @include bp(m) {
        cursor: pointer;
      }
    }
  }

  &.rating--summary-visible {
    .r-summary {
      @include bp(m) {
        display: block;
      }
    }
  }

  &.rating--product-overview {
    @include bp(xs, max) {
      .r-stars {
        margin-right: 0;
      }
    }

    :deep(.bv_main_container) {
      .bv_ratings_summary {
        .bv_avgRating_component_container,
        .bv_numReviews_component_container .bv_numReviews_text {
          font-weight: map-get($font-weights, 'normal') !important;
        }
      }

      .bv_button_component_container .bv_button_buttonMinimalist {
        font-weight: map-get($font-weights, 'normal') !important;
      }

      > div.bv_main_container_row_flex:first-of-type {
        @include bp(s, max) {
          margin-top: $pad * 0.625 !important;
        }

        @include bp(xs, max) {
          display: flex !important;
          justify-content: space-between !important;
          padding-right: 0 !important;
          width: 100% !important;

          .bv_main_container_row_flex {
            padding-right: 0 !important;

            button {
              font-size: map-get($font-sizes, 'm') !important;
              font-weight: map-get($font-weights, 'normal') !important;
            }
          }
        }
      }
    }
  }
}
</style>
